import React, { useEffect } from "react";

const CodeBlock = ({ code, language }) => {
  useEffect(() => {
    // Highlight the code after rendering
    window.Prism.highlightAll();
  }, [code]);

  return (
    <pre className="max-sm:w-[80vw]">
      <code className={`language-${language}`}>{code}</code>
    </pre>
  );
};

export default CodeBlock;
